export interface Subscription {
  unsubscribe: () => void;
}
